<template>
  <el-form label-position="top" @submit.prevent="submit">
    <el-form-item :label="$t('locationGroups.fields.name')" :error="nameError">
      <el-input v-model="name" maxlength="120" autofocus @keyup.enter="submit" />
    </el-form-item>
    <div class="location-group-editor__inputs">
      <el-form-item :label="$t('locationGroups.fields.available')">
        <el-input v-model="available" type="textarea" :rows="6" />
      </el-form-item>
      <el-form-item :label="$t('locationGroups.fields.unavailable')" :error="locationsError">
        <el-input v-model="unavailable" type="textarea" :rows="6" />
      </el-form-item>
    </div>
    <GeolocationMapPreview :locations="geolocations" show-availability-legend />
    <div class="location-group-editor__actions">
      <el-button native-type="button" @click="emit('cancel')">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" native-type="submit" :loading="submitting">
        {{ $t(mode === 'create' ? 'common.create' : 'common.update') }}
      </el-button>
    </div>
  </el-form>
</template>

<script setup lang="ts">
import { watch } from 'vue'

import GeolocationMapPreview from '@/views/dashboard/components/GeolocationAreasEditor/GeolocationMapPreview.vue'

import { useLocationGroupEditor } from '../composables/useLocationGroupEditor'
import type { LocationGroup, LocationGroupDraft } from '../domain/locationGroup'

const props = defineProps<{
  group?: LocationGroup
  submitting: boolean
}>()

const emit = defineEmits<{
  cancel: []
  submit: [draft: LocationGroupDraft]
}>()

const { mode, name, available, unavailable, geolocations, nameError, locationsError, reset, buildDraft } =
  useLocationGroupEditor()

watch(
  () => props.group,
  group => reset(group),
  { immediate: true }
)

function submit(): void {
  if (props.submitting) return
  const draft = buildDraft()
  if (draft) emit('submit', draft)
}
</script>

<style scoped lang="scss">
.location-group-editor {
  &__inputs {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 16px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 20px;
  }
}
</style>
